import React from 'react';

import { Container } from './styles';

import DropdownLazy from '../../../../components/DropdownLazy';

function DropDownLazy(props) {
  const { required, ...rest } = props;

  return (
    <Container required={required}>
      <DropdownLazy className={required ? 'required' : ''} {...rest} />
    </Container>
  );
}

export default DropDownLazy;
